/**
 * Format date to Arabic format with time
 * @param date - Date object or string to format
 * @returns Formatted date string in Arabic
 */
export const getDate = (date: Date | string): string => {
  const dateObj = typeof date === "string" ? new Date(date) : date;

  // Format date part
  const datePart = new Intl.DateTimeFormat("ar-EG-u-nu-latn", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(dateObj);

  // Format time part with AM/PM detection
  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const period = hours < 12 ? "صباحًا" : "مساءً";

  if (hours === 0) {
    hours = 12; // midnight
  } else if (hours > 12) {
    hours -= 12; // convert to 12-hour format
  }

  const timePart = `${hours}:${minutes} ${period}`;

  // Final output
  return `${datePart} - ${timePart}`;
};
